import { render } from "./MarketingServicesBenefits.vue?vue&type=template&id=4df5db53"
import script from "./MarketingServicesBenefits.vue?vue&type=script&lang=js"
export * from "./MarketingServicesBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__